import { Component, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  animations: [
    trigger('carouselAnimation', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate('500ms', style({ opacity: 0 }))
      ])
    ]),
    trigger('carouselAppear', [
      transition('void => *', [
        style({ transform: 'translateY(-10px)' }),
        animate('300ms ease-in-out')
      ]),
    ])
  ]
})
export class CarouselComponent {
  @Input() slides: any[];

  @Input() config = {
    arrows: false,
    dots: true,
    autoplay: false, // To implement
  };

  currentSlide = 0;

  constructor() { }

  onPreviousClick() {
    const previous = this.currentSlide - 1;

    this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
  }

  onNextClick() {
    const next = this.currentSlide + 1;

    this.currentSlide = next === this.slides.length ? 0 : next;
  }

  onJumpTo = i => this.currentSlide = i;
}
